import { MutationCache, QueryClient } from '@tanstack/react-query'
import { apiErrorMessage } from '@/features/settings/apiErrorMessage'
import { pushToast } from '@/lib/toastStore'

/**
 * Single shared TanStack Query client.
 *
 * Defaults are tuned for a CRM use case:
 *   - Data is reasonably fresh for a minute (staleTime), then re-fetched when the window regains
 *     focus. Focus re-fetch matters because data can change outside this session — e.g. a contact
 *     opting out via the public /unsubscribe page sets do_not_email server-side; on returning to the
 *     tab the contact list/detail refreshes instead of showing a stale consent state until a manual reload.
 *   - Failed queries retry once (network blips), but auth errors should not retry.
 *
 * The mutation cache carries a global error net: every failed mutation shows a toast, so no
 * write can fail completely silently. Components may still add their own onError for richer,
 * inline context (both fire) — this is the safety floor, not a replacement.
 */
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error) => pushToast(apiErrorMessage(error)),
  }),
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
